import { CountryCode } from '@rover/constants/src/geography/geo.constants';
import type { Address } from '@rover/types/src/Address';

export function getCityZipAddressLine(address?: Address): string {
  if (!address) return '';
  return `${address.city}, ${address.state} ${address.zip}, ${address.countryCode ?? ''}`;
}

export function isStateRequired(countryCode?: CountryCode): boolean {
  return countryCode === CountryCode.US || countryCode === CountryCode.CA;
}

export function isValidAddress(address?: Address): boolean {
  return !!(
    address &&
    address.city &&
    ((isStateRequired(address.countryCode) && address.state) ||
      !isStateRequired(address.countryCode)) &&
    address.addressLine1 &&
    address.zip
  );
}
